import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Divider, Grid2, Paper, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ConfirmDialog from "components/common/ConfirmDialog";
import { ACTION_STATES } from "core/actions";
import log from "loglevel";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SettingsTemplateForm from "./SettingsTemplateForm";
import SettingsTemplateListItem from "./SettingsTemplateListItem";
import { actions } from "./logic/actions";
import "./templateList.scss";

const SettingsTemplatesList = ({
    getReviewTemplates,
    reviewTemplates,

    deleteTemplate,
    clear,
    deletingTemplate,
}) => {
    const [openForm, setOpenForm] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [id, setId] = useState(null);
    const [name, setName] = useState("");
    const [value, setValue] = useState("");
    const [deleteId, setDeleteId] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);

    let deleted = deletingTemplate === ACTION_STATES.SUCCESS;

    useEffect(() => {
        getReviewTemplates({ namePattern: "" });
    }, [getReviewTemplates]);

    useEffect(() => {
        if (deleted) {
            clear();
            handleCloseDeleteConfirmation();
        }
    }, [clear, deleted, deletingTemplate]);

    log.debug("reviewTemplates", reviewTemplates);

    function handleOpenEdit(templateId, templateName, templateValue) {
        setEditMode(true);
        setId(templateId);
        setName(templateName);
        setValue(templateValue);
        setOpenForm(true);
    }

    function handleClose() {
        setEditMode(false);
        setId(null);
        setName("");
        setValue("");
        setOpenForm(false);
    }

    function handleOpenConfirmation(templateId) {
        setDeleteId(templateId);
        setOpenConfirmation(true);
    }

    function handleCloseDeleteConfirmation() {
        setDeleteId(null);
        setOpenConfirmation(false);
    }

    function deleteConfirmed() {
        deleteTemplate(deleteId);
    }

    const dialog = (
        <Dialog handleClose={handleClose} open={openForm} fullWidth maxWidth="lg">
            <DialogTitle>
                <Grid2 container wrap="nowrap">
                    <Grid2 container  alignItems="center" size={11}>
                        <Typography variant="h5"> {editMode ? "Edit" : "Add"} Template</Typography>
                    </Grid2>
                    <Grid2 container  justify="flex-end" size={1}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid2>
                </Grid2>
            </DialogTitle>
            <Divider />
            <Grid2 size={12}>
                <SettingsTemplateForm
                    id={id}
                    handleClose={handleClose}
                    name={name}
                    value={value}
                    editing={editMode}
                    changeName={setName}
                    changeValue={setValue}
                />
            </Grid2>
        </Dialog>
    );

    const confirmDeleteDialog = (
        <ConfirmDialog
            open={openConfirmation}
            message="Are you sure do you want to delete this template?"
            confirmText="Yes"
            closeText="No"
            onConfirm={deleteConfirmed}
            onCancel={handleCloseDeleteConfirmation}
        />
    );

    return (
        (<Grid2
            className="settings-template-list"
            container
            spacing={2}
            style={{ position: "relative", height: "85vh", display: "block" }}
        >
            {dialog}
            {confirmDeleteDialog}
            <Grid2 size={12}>
                <Paper>
                    <div className="toolbar" style={{ display: "flex", flex: 1 }}>
                        <Button
                            size={"small"}
                            variant={"outlined"}
                            startIcon={<AddIcon />}
                            onClick={() => setOpenForm(true)}
                        >
                            Add Template
                        </Button>
                        <Button size={"small"} variant={"outlined"} startIcon={<RefreshIcon />}>
                            Refresh
                        </Button>
                    </div>
                    <div style={{ display: "block", maxHeight: "calc(100vh - 180px)", overflowY: "auto" }}>
                        {reviewTemplates.map((template) => (
                            <Grid2 className="stripe-row" key={template.id}  size={12}>
                                <SettingsTemplateListItem
                                    {...template}
                                    handleEdit={handleOpenEdit}
                                    handleDelete={handleOpenConfirmation}
                                />
                            </Grid2>
                        ))}
                    </div>
                </Paper>
            </Grid2>
        </Grid2>)
    );
};

SettingsTemplatesList.propTypes = {
    getReviewTemplates: PropTypes.func.isRequired,
    reviewTemplates: PropTypes.array.isRequired,
    deleteTemplate: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    deletingTemplate: PropTypes.string.isRequired,
};
const mapStateToProps = ({ templateSettings }) => ({
    reviewTemplates: templateSettings.reviewTemplates,
    deletingTemplate: templateSettings.deletingTemplate,
});

const mapDispatchToProps = (dispatch) => ({
    getReviewTemplates: (query) => dispatch(actions.GET_REVIEW_TEMPLATES.send(query)),
    deleteTemplate: (id) => dispatch(actions.DELETE_TEMPLATE.send(id)),
    clear: () => dispatch(actions.CLEAR.call()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTemplatesList);
